import { render } from "./upload-image.vue?vue&type=template&id=8bab6502&scoped=true"
import script from "./upload-image.vue?vue&type=script&lang=js"
export * from "./upload-image.vue?vue&type=script&lang=js"

import "./upload-image.vue?vue&type=style&index=0&id=8bab6502&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bab6502"]])

export default __exports__